import {
  ChakraAsyncSelect,
  HStack,
  IconButton,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
} from '@elkaso-app/web-design';
import { FiFilter, FiX } from 'react-icons/fi';

type TOption = {
  value: string | number;
  label: string;
};

interface IFilterableTableHeader {
  name: string;
  sortButtonComponent?: React.ReactNode;
  filterValue: TOption | null;
  onFilterChange: (value: TOption | null) => void;
  loadOptions: (inputValue: string, callback: any) => void;
  placeholder: string;
}

export const FilterableTableHeader: React.FC<IFilterableTableHeader> = ({
  name,
  sortButtonComponent,
  filterValue,
  onFilterChange,
  loadOptions,
  placeholder,
}) => {
  return (
    <HStack spacing={2}>
      <Text fontWeight='medium'>{name}</Text>
      {sortButtonComponent}
      <Popover placement='bottom-start'>
        <PopoverTrigger>
          <IconButton
            aria-label={`Filter ${name}`}
            icon={<FiFilter />}
            size='xs'
            variant={filterValue ? 'solid' : 'ghost'}
            colorScheme={filterValue ? 'blue' : 'gray'}
          />
        </PopoverTrigger>
        <PopoverContent width='300px'>
          <PopoverBody>
            <ChakraAsyncSelect
              placeholder={placeholder}
              isClearable
              value={filterValue}
              onChange={(newValue) => onFilterChange(newValue as TOption | null)}
              loadOptions={loadOptions}
              cacheOptions
              defaultOptions
              size='sm'
            />
          </PopoverBody>
        </PopoverContent>
      </Popover>
      {filterValue && (
        <IconButton
          aria-label={`Clear ${name} filter`}
          icon={<FiX />}
          size='xs'
          variant='ghost'
          colorScheme='red'
          onClick={() => onFilterChange(null)}
        />
      )}
    </HStack>
  );
};
